import Image from 'next/image';
import type { RefObject } from 'react';
import { Block } from '@/components/pages/block';
import type { ProcessStepsProps } from '../type';
import { defaultTitle } from '../constants';
import { ProcessStepsCarouselDesktopItem } from './item';

const INITIAL_HEIGHT = 1070;

type ServerProps = ProcessStepsProps & {
  activeIndex?: number;
  progress?: number;
  totalHeight?: number;
  containerRef?: RefObject<HTMLDivElement | null>;
  stickyRef?: RefObject<HTMLDivElement | null>;
  onItemClick?: (index: number) => void;
};

export function ProcessStepsCarouselDesktopServer({
  steps,
  title,
  activeIndex = 0,
  progress = 0,
  totalHeight = INITIAL_HEIGHT,
  containerRef,
  stickyRef,
  onItemClick,
}: ServerProps) {
  return (
    <div ref={containerRef} style={{ height: `${totalHeight}px` }}>
      <div ref={stickyRef} className="sticky top-0">
        <Block>
          <h2
            className="section-title text-center text-brand-text-button [&_i]:section-subtitle @md:[&_br]:hidden"
            dangerouslySetInnerHTML={{ __html: title || defaultTitle }}
          />
          <div className="grid grid-cols-2 gap-12.5 rounded-4xl bg-[linear-gradient(253.32deg,#2563EB_-6.11%,#0369A1_49.31%,#05195E_96.19%)] overflow-clip p-20 mt-14">
            <div className="flex flex-col justify-center">
              {(steps.content?.data || []).map((item, index) => (
                <ProcessStepsCarouselDesktopItem
                  key={`${item.position}-${index}`}
                  order={index + 1}
                  title={item.title}
                  subtitle={item.subtitle}
                  isActive={index === activeIndex}
                  progress={index === activeIndex ? progress : 0}
                  onClick={onItemClick ? () => onItemClick(index) : undefined}
                />
              ))}
            </div>

            <div className="relative overflow-hidden">
              {steps.content.data.map((item, index) => (
                <div
                  key={`image-${index}-${item.position}`}
                  className={`absolute inset-0 transition-opacity duration-700 rounded-2xl overflow-hidden ${
                    index === activeIndex ? 'opacity-100' : 'opacity-0'
                  }`}
                >
                  <Image
                    src={item.image}
                    alt={item.title}
                    width={600}
                    height={600}
                    className="w-full h-full object-cover"
                    sizes="(max-width: 1024px) 100vw, 50vw"
                  />
                </div>
              ))}
            </div>
          </div>
        </Block>
      </div>
    </div>
  );
}
